import { render, staticRenderFns } from "./BusinessPurchase.vue?vue&type=template&id=185af02e&scoped=true"
import script from "./BusinessPurchase.vue?vue&type=script&lang=js"
export * from "./BusinessPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185af02e",
  null
  
)

export default component.exports